// Entry point for the build script in your package.json
import jQuery from 'jquery';
import '@fortawesome/fontawesome-free/js/all';
// Expose jQuery globally
window.$ = jQuery;
window.jQuery = jQuery;

import "@hotwired/turbo-rails";
import "./controllers"
import * as bootstrap from "bootstrap";
import * as dragdrop from "./dragdrop";
import * as linker from "./linker";
